// ─────────────────────────────────────────────────────────────
// INFINI — main.tsx
// PostHog must be initialised BEFORE React mounts so that the
// pioneer_landing_viewed event captures the correct referrer/UTM
// data from the initial page URL.
// ─────────────────────────────────────────────────────────────

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// ① Initialise PostHog first — before any component code runs.
import { initPostHog } from '@/lib/analytics/posthog';
initPostHog();

// ② Then mount the app.
import App from './App';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
